import type { RowDataAttributes } from './DetailList';
import styles from './EmptyHint.module.css';

/**
 * 🔒 The inside-a-card empty sentence (piece 4; T178), in one place. It replaces
 * the `length === 0` ternary that stood at a hundred sites, each reaching for
 * whichever muted class its own page stylesheet happened to carry.
 *
 * 🔨 It is not the whole-region empty state. Where a region has nothing at all to
 * draw, the async panel says so and names the next action; this is a card that
 * keeps its own heading and states that the list beneath it is empty.
 *
 * 🔨 Every `data-*` attribute the caller passes lands on the paragraph verbatim,
 * because a suite reads the sentence by it.
 */
export interface EmptyHintProps extends RowDataAttributes {
  /** The card's own sentence, through `t()`. */
  text: string;
}

export function EmptyHint({ text, ...data }: EmptyHintProps) {
  return <p className={styles.hint} {...data}>{text}</p>;
}
